import { Injectable } from '@angular/core';
import { RaintreeResponse } from '../interfaces/raintree-response';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';
import {
  MemberSearchResponseData,
  OnSubmitUpdateResponseData,
  SpecificMemberResponseData,
} from '../interfaces/member-search';

@Injectable({
  providedIn: 'root',
})
export class UpdateMemberService extends ApiService {
  public fetchMemberDetails(
    updateObj: any
  ): Observable<MemberSearchResponseData> {
    return this.post<MemberSearchResponseData>(ROUTES.MEMBER_SEARCH, {
      body: updateObj,
    });
  }

  public updateMemberDetails(
    memberId: Number,
    updateObj: any
  ): Observable<OnSubmitUpdateResponseData> {
    return this.patch<OnSubmitUpdateResponseData>(
      this.replacePathInfo(ROUTES.UPDATE_SPECIFIC_MEMBER, {
        memId: memberId,
      }),
      {
        body: updateObj,
      }
    );
  }

  public fetchInactiveReason(
  ): Observable<any> {
    return this.get<any>(
      ROUTES.INACTIVE_REASON
    );
  }

  public fetchSpecificMemberDetails(
    memberId: Number,
  ): Observable<SpecificMemberResponseData> {
    return this.get<SpecificMemberResponseData>(
      this.replacePathInfo(ROUTES.UPDATE_MEMBER, {
        memId: memberId,
      }),

    );
  }
}
